import React, { useState } from 'react'
import { bool, func, object, string } from 'prop-types'
import { getColaboratorsWithoutPosted } from '../../../dashboard/functions/generateReport'
import FilterButton from '../../../../components/buttons/FilterButton'
import BasicModal from '../../../../components/shared/modals/BaseModal'
import { BaseDatePicker } from '../../../../components/shared'
import { Button, styled } from '@mui/material'

ModalAusencia.propTypes = {
  status: bool,
  setStatus: func,
  query: object,
  bibliotecaName: string
}

function AusenciaButton({ ...props }) {
  return (
    <FilterButton
      color="white"
      {...props}
      text="Relatorio de Ausência de Leitura"
    />
  )
}

const StyledLabel = styled('p')`
  color: rgb(70 70 70);
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 1.05rem;
`
export default function ModalAusencia({
  status,
  setStatus,
  query,
  bibliotecaName
}) {
  const [mes, setMes] = useState(null)
  const [currentMonth, setCurrentMonth] = useState(null)
  const formatMesAno = value => {
    let { $M } = value

    $M = $M + 1
    setMes(value)
    setCurrentMonth($M)
  }
  return (
    <BasicModal
      title="Ausência de Leitura"
      Caller={AusenciaButton}
      status={status}
      closeEvent={event => {
        setStatus(event)
      }}
      sx={{
        minWidth: '22vw',
        width: { xs: '100vw', md: '32vw', xl: '22vw' }
      }}
    >
      <form>
        <div className="d-flex justify-between">
          <div>
            <StyledLabel>Biblioteca: {bibliotecaName}</StyledLabel>
          </div>
          <div>
            <StyledLabel>Ano: {query.ano}</StyledLabel>
          </div>
        </div>
        <BaseDatePicker
          value={mes}
          onChange={formatMesAno}
          label="Mês"
          inputFormat="MM"
          mask="__"
          openTo="month"
          views={['month']}
        />
        <Button
          type="button"
          onClick={() => {
            getColaboratorsWithoutPosted({
              ano: query.ano,
              biblioteca: query.biblioteca,
              mes: currentMonth
            })

            setTimeout(() => {
              setStatus(false)
            }, 500)
          }}
          style={{ marginTop: '1rem' }}
          variant="contained"
        >
          Ver Relatório
        </Button>
      </form>
    </BasicModal>
  )
}
